export default __webpack_public_path__ + "components/weather-icon/static/nightlightsnow@2-61466b44d40fd95bc33f8f330c16dc31.png";